export default "__VITE_ASSET__DWCG2IJL__"